








import Vue from "vue";
import log from "loglevel";

import {
  PostChangePlansRequest,
  PostChangePlansResponse
} from "@/containers/changePlansSb/api";
import { mapActions } from "vuex";

type Props = {
  apiRequestParams: PostChangePlansRequest;
  waitingTime: number;
  paymentType: string;
  completeUrl: string;
  applicationSuccessUrl: string;
  sendInvoiceUrl: string;
  errorUrl: string;
};

type Data = {
  isComplete: boolean;
};

type Method = {
  executionPostChangePlans: () => void;
  postChangePlans: (
    params: PostChangePlansRequest
  ) => Promise<PostChangePlansResponse>;
};

export default Vue.extend<Data, Method, {}, Props>({
  name: "vc-change-plans-sb-register",
  props: {
    apiRequestParams: {
      default: () => ({
        deviceType: "",
        gradeType: "",
        termType: "",
        contractNumber: "",
        key: "",
        basetime: 0
      })
    },
    waitingTime: { default: 0 },
    paymentType: { default: "" },
    completeUrl: { default: "" },
    applicationSuccessUrl: { default: "" },
    sendInvoiceUrl: { default: "" },
    errorUrl: { default: "" }
  },
  data() {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionPostChangePlans();
  },
  methods: {
    ...mapActions("changePlansSb", ["postChangePlans"]),
    async executionPostChangePlans() {
      try {
        const res = await this.postChangePlans(this.apiRequestParams);

        // PAY-1594の対応
        // 契約変更の処理内容によってはsetActiveMenuの実行タイミングとかぶってリクエストがcanceledになることがあるため、かぶらないように2秒待つ
        setTimeout(() => {
          this.isComplete = true;

          if (this.paymentType === "billing") {
            window.location.href = `${this.sendInvoiceUrl}?contractPlanChangeId=${res.contractPlanChangeId}`;
          } else if (res.isSettlementComplete) {
            window.location.href = `${this.completeUrl}?contractPlanChangeId=${
              res.contractPlanChangeId
            }&isSmallPayment=${Number(res.isSmallPayment)}`;
          } else {
            window.location.href = `${this.applicationSuccessUrl}?contractPlanChangeId=${res.contractPlanChangeId}`;
          }
        }, 2000);
      } catch (error) {
        log.error(error);

        if (error.data && error.data.returnUrl) {
          window.location.href = error.data.returnUrl;
        } else {
          window.location.href = this.errorUrl + "?type=default_error";
        }

        throw error;
      }
    }
  }
});
